module.exports = __webpack_public_path__ + "img/40_69_006_380.12958df9.jpg";